import api from "api/axios";

export const getArticles = (params) =>
  api.get("/articles", { params });

export const getArticleById = (id) =>
  api.get(`/articles/${id}`);

export const createArticle = (payload) =>
  api.post("/articles", payload);

export const updateArticle = (id, payload) =>
  api.put(`/articles/${id}`, payload);

export const deleteArticle = (id) =>
  api.delete(`/articles/${id}`);
